/**
 * Layout classification for responsive UI.
 * Uses the viewport's shorter edge so phones in landscape still match Tailwind-scale
 * compact layout (~ `md`: 768px) instead of flipping to desktop when width crosses 768.
 */
export const MOBILE_LAYOUT_MAX_SHORT_EDGE_PX = 768;

/**
 * @param {number} innerWidth
 * @param {number} innerHeight
 * @returns {{
 *   innerWidth: number,
 *   innerHeight: number,
 *   shortEdge: number,
 *   longEdge: number,
 *   isMobileLayout: boolean,
 *   isDesktopLayout: boolean,
 *   isLandscape: boolean,
 *   isPortrait: boolean,
 * }}
 */
export function computeDeviceLayout(innerWidth, innerHeight) {
  const shortEdge = Math.min(innerWidth, innerHeight);
  const longEdge = Math.max(innerWidth, innerHeight);
  const isMobileLayout = shortEdge < MOBILE_LAYOUT_MAX_SHORT_EDGE_PX;
  const isLandscape = innerWidth >= innerHeight;

  return {
    innerWidth,
    innerHeight,
    shortEdge,
    longEdge,
    isMobileLayout,
    isDesktopLayout: !isMobileLayout,
    isLandscape,
    isPortrait: !isLandscape,
  };
}
